// Load initial state from localStorage
const loadStateFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem('sessionState');
    if (serializedState === null) {
      // Check for old format (individual items)
      const oldSessionId = localStorage.getItem('sessionId');
      const oldUserId = localStorage.getItem('userId');
      const oldUserName = localStorage.getItem('userName');
      
      if (oldSessionId) {
        const migratedState = {
          sessionId: oldSessionId,
          setUser: null,
          setUserPhoto: null, // Don't restore photos from localStorage
          setUserId: oldUserId ? JSON.parse(oldUserId) : null,
          setUserName: oldUserName ? JSON.parse(oldUserName) : null,
        };
        
        // Save migrated state in new format (without photo)
        localStorage.setItem('sessionState', JSON.stringify(migratedState));
        
        return migratedState;
      }
      
      return {
        sessionId: null,
        setUser: null,
        setUserPhoto: null,
        setUserId: null,
        setUserName: null,
        isAdmin: false,
      };
    }
    
    const parsedState = JSON.parse(serializedState);
    // Ensure setUserPhoto is not restored from localStorage to prevent quota issues
    return {
      ...parsedState,
      setUserPhoto: null,
      isAdmin: parsedState.isAdmin || false,
    };
  } catch (error) {
    console.error('Error loading state from localStorage:', error);
    // Clear corrupted localStorage
    localStorage.removeItem('sessionState');
    return {
      sessionId: null,
      setUser: null,
      setUserPhoto: null,
      setUserId: null,
      setUserName: null,
      isAdmin: false,
    };
  }
};

const initialState = loadStateFromLocalStorage();

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SESSION_ID":
      return {
        ...state,
        sessionId: action.payload,
      };
    case "SET_USER_ID":
      return {
        ...state,
        setUserId: action.payload,
      };
    case "SET_USER":
      return {
        ...state,
        setUser: action.payload,
      };
    case "SET_USER_PHOTO":
      return {
        ...state,
        setUserPhoto: action.payload,
      };
    case "SET_USER_NAME":
      return {
        ...state,
        setUserName: action.payload,
      };
    case "SET_IS_ADMIN":
      return {
        ...state,
        isAdmin: action.payload,
      };
    case "CLEAR_SESSION":
      return {
        sessionId: null,
        setUser: null,
        setUserPhoto: null,
        setUserId: null,
        setUserName: null,
        isAdmin: false,
      };

    default:
      return state;
  }
};
export default sessionReducer;
